import MODULE_ID from './moduleId';
import { performInMemorySearch } from '@/components/search/searchStore';

const getters = {
  getNews: (state) => (instance) => {
    let selectedLabelId = state.selectedLabelId ? [state.selectedLabelId] : [];
    console.debug(`getNews with instance=${instance} for selectedLabelId`, selectedLabelId);
    let news = state.news.filter((n) => n.instance === instance);
    // skip label filter in case we want to see all unread news

    return news
      .filter((n) => {
        if (!selectedLabelId || (Array.isArray(selectedLabelId) && selectedLabelId.length === 0)) {
          return true;
        }

        // No labels
        if (!n._labels) return false;
        if (n._labels.length === 0) return false;

        let containsAll = true;
        selectedLabelId.forEach((labelId) => {
          let labelsContains = n._labels.find((label) => label.labelIdFk === labelId);

          containsAll = labelsContains !== undefined && containsAll === true;
        });
        return containsAll;
      })
      .filter((n) => {
        // console.debug(`filter for showUnreadOnly=${state.showUnreadOnly} n._userState=${JSON.stringify(n._userState, null)}`);
        if (state.showUnreadOnly) {
          return n._userState.dateread === null;
        }
        return true;
      });
  },
  getAllUsedLabels: (state) => (instance) => {
    if (instance) {
      let labelsByInstance = state.labelsByInstance[instance] ? state.labelsByInstance[instance] : [];
      return labelsByInstance.filter((l) => l._usageCount > 0);
    }
    return [];
  },

  /** ------------------------------------------------------------------------------------------------------------------
   * Module Implementation for unread badge counts by instance.
   * IMPLEMENT this getter to enable unread counter badges
   * -------------------------------------------------------------------------------------------------------------------
   */
  getUnreadCountByModuleInstance: (state) => (instance) => {
    if (state.unreadCountsByInstance[instance]) {
      return state.unreadCountsByInstance[instance];
    }
    return 0; //TODO: Review if this is correct
  },
};
export default getters;
